import { render, staticRenderFns } from "./bindAccess.vue?vue&type=template&id=3572bf08&scoped=true"
import script from "./bindAccess.vue?vue&type=script&lang=js"
export * from "./bindAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572bf08",
  null
  
)

export default component.exports